import { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import './index.scss';

type TButtonProps = {
  variant?:
    | 'primary'
    | 'secondary'
    | 'outlined'
    | 'unstyled'
    | 'link'
    | 'dialog';
  size?: 'small' | 'medium' | 'large';
  link?: string;
  state?: string;
  children: ReactNode;
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & TButtonProps;

export const Button: FC<ButtonProps> = props => {
  const {
    type = 'button',
    className = '',
    children,
    variant,
    size,
    disabled = false,
    onClick,
    link,
    ...rest
  } = props;

  const buttonClassName = `button ${className}${
    variant ? ` button--${variant}` : ''
  }`;

  if (link) {
    // Исключаем пропсы, специфичные для button, при рендеринге Link
    const {
      type: _type,
      disabled: _disabled,
      onClick: _onClick,
      ...linkProps
    } = rest as ButtonHTMLAttributes<HTMLButtonElement>;

    return (
      <Link
        to={link}
        state
        className={buttonClassName}
        data-size={size}
        {...(linkProps as Partial<LinkProps>)}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      className={buttonClassName}
      data-size={size}
      type={type}
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      {...rest}
    >
      {children}
    </button>
  );
};
